import Vue from 'vue'
import Vuex from 'vuex'

import settings from './modules/settings'
import secure from './modules/secure'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    registered: false
  },
  mutations: {

    /** данный флажок ставим в позицию true после регистрации, для того,
     * чтобы после навигации "Назад" со страницы поиска услуг вызвать пропуск этапа привязки услуг
     * и вернуть корректный ответ приложению
     */
    SET_REGISTERED(state, value) {
      state.registered = value
    }

  },
  actions: {
  },
  modules: {
    settings, secure
  }
})
